// extracted by mini-css-extract-plugin
export default {"tooltip_content_paragraph":"TrHsugg2KS5Dl5IPKh6g","tooltip_content_list":"flnOPnTCsz21DevDD5b7","tooltip_content_item":"cTue8CbpyJ2uZqLzpw_9"};